import React from 'react';
import './BaseScreen.css';
import Header from './Header';
import Footer from './Footer';

function BaseScreen({ children }) {
  return (
    <div className="base-screen">
      <Header />
      <main className="main-content">
        {children}
      </main>
      <Footer />
    </div>
  );
}

export default BaseScreen;
